import { Card, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import SelectComponent from '../../common/SelectComponent/SelectComponent';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import { useSelector } from 'react-redux';

const QuotationFilter = ({ supplierSelectRef }) => {
  const { t } = useTranslation();

  const { productNames, suppliers, materialTypes } = useSelector(
    state => state.quotation
  );

  return (
    <Card
      className="bg-fills-white rounded-lg border-none md:px-40 md:py-32 p-16"
      classNames={{ body: '!p-0' }}
    >
      <div className="grid md:grid-cols-4 grid-cols-1 items-end justify-start gap-16">
        <Form.Item
          name="supplier"
          label={t('quotation.provider', 'Nhà Cung Cấp')}
          className="flex flex-col gap-2"
        >
          <SelectComponent
            ref={supplierSelectRef}
            placeholder={t('quotation.selectProvider', 'Chọn nhà cung cấp')}
            options={[...suppliers.data?.map(s => ({ label: s, value: s }))]}
            allowClear={true}
          />
        </Form.Item>

        {/* <Form.Item
          label={t('quotation.product', 'Sản Phẩm')}
          className="flex flex-col gap-2"
        >
          <SelectComponent
            placeholder={t('quotation.selectProduct', 'Chọn sản phẩm')}
            options={products}
            allowClear={true}
          />
        </Form.Item> */}

        {/* <Form.Item className="flex flex-col gap-2">
          <ButtonPrimaryLarge
            onClick={handleReset}
            className="w-full"
            title={t('quotation.reset', 'Đặt Lại')}
          />
        </Form.Item> */}
      </div>
    </Card>
  );
};

export default QuotationFilter;
